import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { IPostLocalizationResponse } from '../user-preferences/post-localization.action';

/**
 * SetFavoriteProducts Input Action
 */
export class SetFavoriteProductsInput implements Msdyn365.IActionInput {
    public favoriteProduct: string;
    public mode: 'patch' | 'delete';
    constructor(favoriteProduct: string, mode: 'patch' | 'delete') {
        this.favoriteProduct = favoriteProduct;
        this.mode = mode;
    }

    public getCacheKey = () => `SetFavoriteProducts`;
    public getCacheObjectType = () => 'SetFavoriteProducts';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface ISetFavoriteProductsResponse {
    success: boolean;
    message?: string;
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SetFavoriteProductsInput('', 'patch');
};

async function action(input: SetFavoriteProductsInput, ctx: Msdyn365.IActionContext): Promise<ISetFavoriteProductsResponse> {
    ensureAuthenticated(ctx);

    const response = await Msdyn365.sendRequest<ISetFavoriteProductsResponse>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SetFavoriteProducts`,
        `post`,
        { product: input.favoriteProduct, mode: input.mode },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    if (response.status === 500) {
        throw new Error('Error saving localization preferences');
    }

    return {
        ...(response.data || ({} as ISetFavoriteProductsResponse)),
        error: { errorCode: response.status, errorText: response.statusText }
    } as IPostLocalizationResponse;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISetFavoriteProductsResponse>>action,
    id: 'SetFavoriteProducts',
    input: createInput
});
